/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = N/A

1 = QuickBooks

2 = QuickBooks

3 = Xero

4 = QBWebConnected

5 = Sage Intacct


 */
export type IntegrationTypes =
  (typeof IntegrationTypes)[keyof typeof IntegrationTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntegrationTypes = {
  None: 0,
  QBv2: 1,
  QBv3: 2,
  Xero: 3,
  QBWebConnected: 4,
  SageIntacct: 5,
} as const;
